import React from 'react';

import { Modal, Button } from 'antd';

import { PdfViewerComponent } from '../../../shared/components/pdf-viewer';

import './styles.less';

const EditFormModal = ({ isModalVisible, closeModal, rootContainer, fileBytes }) => {
  const onCancelClick = () => {
    closeModal();
  };

  return (
    <Modal
      width={1200}
      title={'Form'}
      open={isModalVisible}
      onCancel={onCancelClick}
      onOk={onCancelClick}
      getContainer={rootContainer}
      className="edit-form-modal"
      footer={[
        <Button key="submit" type="primary" onClick={onCancelClick}>
          Ok
        </Button>,
      ]}
    >
      <PdfViewerComponent fileBytes={fileBytes} rootContainer={rootContainer} disableDeletePages={true} />
    </Modal>
  );
};

export default EditFormModal;
